var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApFireFightingLiftsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1016.359 -222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1016.359 225.952)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.174 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.851,14a.561.561,0,0,0-.384.208l-7.322,8.98a.735.735,0,0,0-.112.723.588.588,0,0,0,.542.4h4.393V42.231a.629.629,0,0,0,.586.665H33.24a.629.629,0,0,0,.586-.665V24.306h4.393a.588.588,0,0,0,.542-.4.735.735,0,0,0-.112-.723L31.327,14.2A.55.55,0,0,0,30.851,14Zm.046,1.642,5.986,7.338H33.24a.629.629,0,0,0-.586.665V41.566H29.139V23.641a.629.629,0,0,0-.586-.665H24.911Z",
    transform: "translate(-22.984 -13.993)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.851,14a.561.561,0,0,0-.384.208l-7.322,8.98a.735.735,0,0,0-.112.723.588.588,0,0,0,.542.4h4.393V42.231a.629.629,0,0,0,.586.665H33.24a.629.629,0,0,0,.586-.665V24.306h4.393a.588.588,0,0,0,.542-.4.735.735,0,0,0-.112-.723L31.327,14.2A.55.55,0,0,0,30.851,14Zm.046,1.642,5.986,7.338H33.24a.629.629,0,0,0-.586.665V41.566H29.139V23.641a.629.629,0,0,0-.586-.665H24.911Z",
    transform: "translate(-22.984 -13.993)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1016.887 222)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.995,
    height: 3.952,
    rx: 1.976,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33.995,
    height: 2.952,
    rx: 1.476,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1016.359 254.048)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.995,
    height: 3.952,
    rx: 1.976,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33.995,
    height: 2.952,
    rx: 1.476,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApFireFightingLiftsIcon);
export default __webpack_public_path__ + "static/media/ap-fire-fighting-lifts-icon.094f67c1eb947daf4ff0172d37267220.svg";
export { ForwardRef as ReactComponent };